
<script>
export default {
    created() {
    },
    mounted() {
    },
    data() {
        return {
        };
    },
    methods: {
    },
    computed: {
    },
    components: {
    }
};
</script>
<template>
<div class="policy">
    <router-view></router-view>
</div>
</template>